var map = {
	".": 59399,
	"./": 59399,
	"./AddLocationModal": 33205,
	"./AddLocationModal.js": 33205,
	"./App": 67186,
	"./App.css": 93508,
	"./App.js": 67186,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./Carousel.css": 66332,
	"./DeletePhotosModal": 12474,
	"./DeletePhotosModal.js": 12474,
	"./Main": 9063,
	"./Main.js": 9063,
	"./ModalComponent": 64743,
	"./ModalComponent.js": 64743,
	"./Navbar.css": 53698,
	"./NavbarComponent": 57082,
	"./NavbarComponent.js": 57082,
	"./Particles": 58702,
	"./Particles.jsx": 58702,
	"./Popup.css": 12748,
	"./PopupComponent": 464,
	"./PopupComponent.js": 464,
	"./SearchBar": 16283,
	"./SearchBar.js": 16283,
	"./SetData": 26350,
	"./SetData.js": 26350,
	"./SettingsModal": 96965,
	"./SettingsModal.js": 96965,
	"./ViewImagesModal": 55311,
	"./ViewImagesModal.js": 55311,
	"./WelcomeScreen": 80156,
	"./WelcomeScreen.js": 80156,
	"./assets/Background.jpg": 75758,
	"./assets/add-image.png": 80828,
	"./assets/all.png": 59239,
	"./assets/ask.png": 9104,
	"./assets/castle.png": 96572,
	"./assets/clipboard.png": 48584,
	"./assets/coins.png": 17096,
	"./assets/landing_page_video.mp4": 90335,
	"./assets/location.gif": 29466,
	"./assets/location.png": 56780,
	"./assets/logo.png": 66949,
	"./assets/logo_test.png": 56896,
	"./assets/logout.png": 86645,
	"./assets/no-money.png": 97067,
	"./assets/nophoto.png": 19622,
	"./assets/noresults.gif": 29725,
	"./assets/paris.png": 52544,
	"./assets/photo-gallery.png": 67379,
	"./assets/reddot.png": 52621,
	"./assets/result.png": 57462,
	"./assets/sign-out-alt.png": 66908,
	"./assets/tower.png": 54871,
	"./assets/user-gear.png": 61223,
	"./database generator/castledata": 68186,
	"./database generator/castledata.json": 68186,
	"./database generator/data.py": 82305,
	"./firebase-config": 82892,
	"./firebase-config.js": 82892,
	"./index": 59399,
	"./index.css": 51174,
	"./index.js": 59399,
	"./particles.css": 27541,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./searchbar.css": 56901,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./views/WelcomeScreen/components/Footer": 68535,
	"./views/WelcomeScreen/components/Footer.js": 68535,
	"./views/WelcomeScreen/components/Loader": 753,
	"./views/WelcomeScreen/components/Loader.js": 753,
	"./views/WelcomeScreen/components/Navbar": 75303,
	"./views/WelcomeScreen/components/Navbar.js": 75303,
	"./views/WelcomeScreen/components/TopSection": 81570,
	"./views/WelcomeScreen/components/TopSection.js": 81570,
	"./welcomescreen.css": 35258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40407;